import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Upload, Modal,Spin  } from "antd";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const UploadFile = ({ sendDataToParent, accept, multiple, defaultFileList = [] }, ref) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState(null);
  const [fileList, setFileList] = useState([]);
const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (defaultFileList.length > 0) {
      setFileList(defaultFileList);
    }
  }, [defaultFileList]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview && file.originFileObj) {
      file.preview = await getBase64(file.originFileObj);
    }

    if (file.type && file.type.includes("video")) {
      setPreviewContent(
        <video
          src={file.url || file.thumbUrl || file.preview}
          style={{ width: "100%",height:"600px" }}
          controls
        />
      );
    } else {
      setPreviewContent(
        <img
          src={file.url || file.thumbUrl || file.preview}
          alt="preview"
          style={{ width: "100%" }}
        />
      );
    }
    setPreviewOpen(true);
  };

const handleChange = async ({ file, fileList: newFileList }) => {
  setFileList(newFileList);
  if (file.status === "uploading") {
    setUploading(true);
  } else if (file.status === "done" || file.status === "error") {
    setUploading(false);
  }
  sendDataToParent(newFileList);
};
  useImperativeHandle(ref, () => ({
    clearFileList: () => setFileList([]),
  }));

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  return (
    <div>
       <Spin spinning={uploading}>
        <Upload
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          onChange={handleChange}
          beforeUpload={() => false}
          accept={accept}
          multiple={multiple}
        >
          {fileList.length >= 8 ? null : uploadButton}
        </Upload>
      </Spin>

      <Modal
        open={previewOpen}
        title="Preview"
        footer={null}
        onCancel={() => setPreviewOpen(false)}
        width={600}
      >
        {previewContent}
      </Modal>
    </div>
  );
};

export default forwardRef(UploadFile);